import type React from 'react';

import { Text } from '@change/ds-core-ui/Text';

import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import { usePageCopy } from '#src/app/pages/psf/promoteOrShare/shared/hooks';
import { Html } from '#src/app/shared/components/html';

import { useContributionHeroCopy } from './hooks/useContributionHeroCopy';

export const ComboStory: React.FC<EmptyProps> = () => {
	const {
		data: { subheadingText2, subheadingContributionHero, subheadingContributionNone, subheadingText3 },
	} = usePageCopy();

	const {
		data: {
			petition: { promotionStats },
		},
	} = usePsfPromoteOrSharePageData();
	const {
		data: { contributionHeroOverride },
	} = useContributionHeroCopy();

	if (!subheadingText3) {
		return <Html as="div" html={subheadingText2} className="text-base md:text-lg" />;
	}

	return (
		<>
			<Text as="h2" variant="heading" size="medium" className="mb-3 md:mb-4">
				{subheadingText2}
			</Text>
			<Html as="div" html={subheadingText3} className="text-typography-strong md:text-lg" />
			{promotionStats.signatureCount > 1 && (
				<Html
					as="div"
					html={contributionHeroOverride ?? (subheadingContributionHero || subheadingContributionNone)}
					className="text-typography-strong mt-7 md:mt-9 md:text-lg"
				/>
			)}
		</>
	);
};
